export const locationTypes = {
    FETCH_REQUEST: "LOCATION_FETCH_REQUEST",
    FETCH_SUCCESS: "LOCATION_FETCH_SUCCESS",
    FETCH_FAILURE: "LOCATION_FETCH_FAILURE",
    CREATE_REQUEST: "LOCATION_CREATE_REQUEST",
    CREATE_SUCCESS: "LOCATION_CREATE_SUCCESS",
    CREATE_FAILURE: "LOCATION_CREATE_FAILURE",
    ALARM_COUNT_SUCCESS: "LOCATION_ALARM_COUNT_SUCCESS",
    DOWNLOAD_REQUEST: "LOCATION_DOWNLOAD_REQUEST",
    DOWNLOAD_SUCCESS: "LOCATION_DOWNLOAD_SUCCESS",
    DOWNLOAD_FAILURE: "LOCATION_DOWNLOAD_FAILURE",
    SET_CURRENT_MODAL:'SET_CURRENT_MODAL',
    UPDATE_UI: "LOCATION_UPDATE_UI",
    UPDATE_PAGINATION_REQUEST: "LOCATION_UPDATE_PAGINATION_REQUEST",
    SET_LOCATION_DATA: "SET_LOCATION_DATA",
    UPLOAD_IMAGE_REQUEST: "LOCATION_UPLOAD_IMAGE_REQUEST",
    UPLOAD_IMAGE_RESPONSE: "LOCATION_UPLOAD_IMAGE_RESPONSE",
    RESET_LOCATION_DATA: "RESET_LOCATION_DATA",
    UPDATE_MODAL: "UPDATE_MODAL",
    DELETE_IMAGE_REQUEST: "DELETE_IMAGE_REQUEST",
    DELETE_IMAGE_RESPONSE: "DELETE_IMAGE_RESPONSE",
    FETCH_IMAGE_REQUEST: "FETCH_IMAGE_REQUEST",
    FETCH_IMAGE_RESPONSE: "FETCH_IMAGE_RESPONSE",
    FETCH_REQUEST_ALL: "LOCATION_FETCH_REQUEST_ALL",
    FETCH_SUCCESS_ALL: "LOCATION_FETCH_SUCCESS_ALL",
    FETCH_FAILURE_ALL: "LOCATION_FETCH_FAILURE_ALL",
    RESET_LOCATION_DATA_ONLY: "RESET_LOCATION_DATA_ONLY",
    UPDATE_ISLOADING: "LOCATION_UPDATE_ISLOADING",
    UPDATE_IS_LOADING_API: "LOCATION_UPDATE_IS_LOADING_API",
    LOCATION_RESET_FILTERS: "LOCATION_RESET_FILTERS",
};

export const setCurrentModal = (data) => ({
    type: locationTypes.SET_CURRENT_MODAL,
    payload: data,
});

export const updateIsApiLoading = (data) => ({
    type: locationTypes.UPDATE_IS_LOADING_API,
    payload: data,
});

export const uploadImageRequest = (data) => ({
    type: locationTypes.UPLOAD_IMAGE_REQUEST,
    payload: data,
});

export const deleteImageRequest = (data) => ({
    type: locationTypes.DELETE_IMAGE_REQUEST,
    payload: data,
});

export const fetchImageRequest = (data) => ({
    type: locationTypes.FETCH_IMAGE_REQUEST,
    payload: data,
});

export const fetchImageResponse = (data) => ({
    type: locationTypes.FETCH_IMAGE_RESPONSE,
    payload: data,
});

export const deleteImageResponse = (data) => ({
    type: locationTypes.DELETE_IMAGE_RESPONSE,
    payload: data,
});

export const resetLocationData = (data) => ({
    type: locationTypes.RESET_LOCATION_DATA,
    payload: data,
});

export const resetLocationDataOnly = (data) => ({
    type: locationTypes.RESET_LOCATION_DATA_ONLY,
    payload: data,
});

export const updateModal = (data) => ({
    type: locationTypes.UPDATE_MODAL,
    payload: data,
});

export const uploadImageResponse = (data) => ({
    type: locationTypes.UPLOAD_IMAGE_RESPONSE,
    payload: data,
});

export const setLocationData = (data) => ({
    type: locationTypes.SET_LOCATION_DATA,
    payload: data,
});

export const fetchRequest = (limit) => ({
    type: locationTypes.FETCH_REQUEST,
    payload: limit
});

export const fetchSuccess = (resp) => ({
    type: locationTypes.FETCH_SUCCESS,
    payload: resp
});

export const fetchRequestAll = () => ({
    type: locationTypes.FETCH_REQUEST_ALL,
});

export const fetchSuccessAll = (resp) => ({
    type: locationTypes.FETCH_SUCCESS_ALL,
    payload: resp
});

export const fetchFailureAll = (resp) => ({
    type: locationTypes.FETCH_FAILURE_ALL,
    payload: resp
});

export const locationAlarmCountSuccess = (resp) => ({
    type: locationTypes.ALARM_COUNT_SUCCESS,
    payload: resp
});

export const fetchFailure = (resp) => ({
    type: locationTypes.FETCH_FAILURE,
    payload: resp
});

export const downloadRequest = () => ({
    type: locationTypes.DOWNLOAD_REQUEST
});

export const downloadSuccess = (resp) => ({
    type: locationTypes.DOWNLOAD_SUCCESS,
    payload: resp
});

export const downloadFailure = (error) => ({
    type: locationTypes.DOWNLOAD_FAILURE,
    payload: error
});

export const createRequest = (req) => ({
    type: locationTypes.CREATE_REQUEST,
    payload: req
});

export const createSuccess = (resp) => ({
    type: locationTypes.CREATE_SUCCESS,
    payload: resp
});

export const createFailure = (resp) => ({
    type: locationTypes.CREATE_FAILURE,
    payload: resp
});

export const updateUI = (resp) => ({
    type: locationTypes.UPDATE_UI,
    payload: resp
});

export const updatePaginationRequest = (req) => ({
    type: locationTypes.UPDATE_PAGINATION_REQUEST,
    payload: req
});

export const resetFilters = (req) => ({
    type: locationTypes.LOCATION_RESET_FILTERS,
    payload: req
});